import './ThirdPartyWebsiteModal.scss';
import React from 'react';
import { connect } from 'react-redux';
import Store from 'state/Store';
import BaseModal from 'components/shared/Modal/BaseModal';
import Content from 'services/Content';
import ActionButton from 'components/shared/Buttons/ActionButton';
import {
  getShowThirdPartyModal,
  getTargetURL
} from 'state/thirdParty/ThirdPartyModalSelectors';
import { showThirdPartyModal } from 'state/thirdParty/ThirdPartyModalActions';

const ThirdPartyWebsiteModal = ({
  hideAnchor,
  hideClose,
  title,
  containerClassName,
  showModal,
  targetURL
}) => {
  const onContinue = () => {
    Store.dispatch(showThirdPartyModal(false));
    window && window.open(targetURL, '_blank');
  };

  return showModal ? (
    <BaseModal
      containerClassName={containerClassName}
      hideAnchor={hideAnchor}
      hideClose={hideClose}
      title={title}
      label="third-party-website-modal"
      disableClickOff
      isOpen={showModal}>
      <p
        className="third-party-website-modal-copy"
        dangerouslySetInnerHTML={{
          __html: Content.accessingThirdPartyWebsiteCopy
        }}
      />
      <div className="third-party-website-modal-footer">
        <ActionButton
          id="cancel-btn"
          onClick={() => Store.dispatch(showThirdPartyModal(false))}>
          Cancel
        </ActionButton>
        <ActionButton id="continue-btn" onClick={onContinue}>
          Continue
        </ActionButton>
      </div>
    </BaseModal>
  ) : null;
};

ThirdPartyWebsiteModal.defaultProps = {
  hideAnchor: true,
  hideClose: true,
  showModal: false,
  title: 'Accessing a Third-Party Website',
  containerClassName: 'third-party-website-modal'
};

const mapStateToProps = (state) => ({
  showModal: getShowThirdPartyModal(state),
  targetURL: getTargetURL(state)
});

export default connect(mapStateToProps)(ThirdPartyWebsiteModal);
